/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'facebook': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M9.3 16V8h2.4l.3-2.8H9.3V3.9c0-.7.1-1.1 1.2-1.1H12V0H9.6C6.7 0 5.7 1.3 5.7 3.6v1.7H4V8h1.7v8h3.6z"/>'
  }
})
